import Vue from 'vue'
import Router from 'vue-router'

const Role = resolve => require(['@/views/Role'], resolve)
const Enterprise = resolve => require(['@/views/Enterprise'], resolve)
const Error404 = resolve => require(['@/views/error/Error404'], resolve)

Vue.use(Router)

let routes = [
    { path: '/', component: resolve => require(['@/views/Home'], resolve) },
    { path: '/v2', component: resolve => require(['@/views/Home2'], resolve) },
    { path: '/openUrls', component: resolve => require(['@/views/OpenUrls'], resolve) },
    { path: '/pageAutoRefresh', component: resolve => require(['@/views/PageAutoRefresh'], resolve) },
    {
        path: '/role',
        component: Role
    },
    {
        path: '/Enterprise',
        component: Enterprise
    },
    {
        path: '*',
        component: Error404
    }
]

let router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js